import { EmailLogin, Login, RecoveryPassword } from '@chi-x/chi-login'
import { openLink } from '@/utils/ReactNative'

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: {
      open_privacy_link: () => {
        return openLink({
          uri: 'https://www.colegiohispanoingles.com/aviso-legal'
        })
      },
      open_term_link: () =>
        openLink({
          uri: 'https://www.colegiohispanoingles.com/politica-de-privacidad'
        })
    },
    meta: { requiresGuess: true }
  },
  {
    path: '/email',
    name: 'Email',
    component: EmailLogin,
    props: {
      open_privacy_link: () =>
        openLink({
          uri: 'https://www.colegiohispanoingles.com/aviso-legal'
        }),
      open_term_link: () =>
        openLink({
          uri: 'https://www.colegiohispanoingles.com/politica-de-privacidad'
        })
    },
    meta: { requiresGuess: true }
  },
  {
    path: '/forgot/password',
    name: 'RecoveryPassword',
    component: RecoveryPassword,
    meta: { requiresGuess: true }
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/router/login.js